import { motion } from "framer-motion";
import { Palette, Users, GraduationCap, Sparkles } from "lucide-react";

const CARDS = [
  {
    icon: Palette,
    color: "#FF4D23",
    title: "My Approach",
    body: "I believe strong design should be distinctive, relevant and purposeful. I build visual systems that strengthen brands, improve communication and perform consistently across customer touchpoints.",
    span: "md:col-span-7",
  },
  {
    icon: Users,
    color: "#00C2FF",
    title: "How I Lead",
    body: "At Venus Remedies, I guide creative execution across brand, marketing, e-commerce and communication projects. My approach combines clear direction, hands-on design involvement and constructive feedback that helps teams produce stronger work.",
    span: "md:col-span-5",
  },
  {
    icon: GraduationCap,
    color: "#FFB800",
    title: "Design Foundation",
    body: "My Master of Design education strengthened my understanding of visual communication, storytelling and critical thinking—helping me move beyond execution and make more considered creative decisions.",
    span: "md:col-span-5",
  },
  {
    icon: Sparkles,
    color: "#00E699",
    title: "AI-Enabled Workflow",
    body: "I integrate generative AI into research, ideation, visual exploration and production workflows to accelerate output while maintaining creative judgment and brand consistency.",
    span: "md:col-span-7",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-20 lg:py-24 border-t border-[#222634]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-mono2 text-xs tracking-[0.3em] uppercase text-[#FF4D23] mb-3">03 · About</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase mb-12" data-testid="about-heading">
          Creative Craft. <span className="text-[#8A92A3]">Strategic Thinking.</span>{" "}
          <span className="text-[#FF4D23]">Collaborative Leadership.</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {CARDS.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`${c.span} bg-[#12141B] border border-[#222634] rounded-2xl p-6 sm:p-8 hover:border-[#3B4254] transition-colors`}
              data-testid={`about-card-${c.title.toLowerCase().replace(/\s/g, "-")}`}
            >
              <c.icon size={26} style={{ color: c.color }} />
              <h3 className="font-display font-bold text-xl sm:text-2xl mt-4 mb-3">{c.title}</h3>
              <p className="text-sm sm:text-base leading-relaxed text-[#B6BDCB]">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
